import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function DivideIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 32 32">
      <circle cx="15.75" cy="9.75" r="1.75" fill="currentColor" />
      <circle cx="15.75" cy="21.75" r="1.75" fill="currentColor" />
    </BaseIcon>
  );
}
